/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { RegistrationFooterButtonProps } from "./interfaces";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import {
  back,
  next,
  ButtonClickType,
  saveText,
  loadingScreenValues,
} from "../../constants/commons";
import { registrationFooterButton } from "./styles";
import { CustomButton } from "../../atoms/CustomButton";
import {
  CustomButtonColor,
  CustomButtonTypes,
} from "../../atoms/CustomButton/interface";
import { ShowMessage } from "../ShowMessage";

export const RegistrationFooterButton: React.FunctionComponent<RegistrationFooterButtonProps> = (
  props
) => {
  const {
    disableNextButton,
    onPositiveActionClick,
    onBackButtonClick,
    isLastStep,
  } = props;
  const [showConfirmModal, setShowConfirmModa] = React.useState<boolean>(false);
  const isMobileView = useIsMobile();
  const isTabView = useIsTab();
  return (
    <span css={registrationFooterButton}>
      <ShowMessage
        visible={showConfirmModal}
        loading={false}
        heading={loadingScreenValues.EVALUATION_MESSAGE}
        description={loadingScreenValues.NO_CHANGES_MESSAGE}
        footerButtons={[
          {
            key: 1,
            text: "Cancel",
            color: CustomButtonColor.SECONDARY,
            type: CustomButtonTypes.BUTTON,
            onClick: (event: React.MouseEvent) => {
              setShowConfirmModa(false);
            },
          },
          {
            key: 2,
            text: "Submit Details",
            color: CustomButtonColor.PRIMARY,
            type: CustomButtonTypes.BUTTON,
            onClick: (event: React.MouseEvent) => {
              setShowConfirmModa(false);
              onPositiveActionClick(ButtonClickType.NEXT);
            },
          },
        ]}
        onCloseIconClick={() => {
          setShowConfirmModa(false);
        }}
      />
      <div
        className={`d-flex bd-highlight my-3 ${
          isMobileView || isTabView
            ? "justify-content-center align-items-center responsive-constant-footer-container"
            : ""
        }`}
      >
        <div className="mr-auto p-2 bd-highlight d-none d-md-block">
          <CustomButton
            className={`px-5 ${isMobileView ? "mobile-btn-height" : ""}`}
            color={CustomButtonColor.DEFAULT}
            type={CustomButtonTypes.BUTTON}
            onClick={() => onPositiveActionClick(ButtonClickType.SAVE_AND_EXIT)}
          >
            {saveText}
          </CustomButton>
        </div>
        <div className="p-2 bd-highlight">
          <CustomButton
            className={`px-5 ${isMobileView ? "mobile-btn-height" : ""}`}
            color={CustomButtonColor.DEFAULT}
            type={CustomButtonTypes.BUTTON}
            onClick={onBackButtonClick}
          >
            {back}
          </CustomButton>
        </div>
        <div className="p-2 bd-highlight">
          <CustomButton
            className={`px-5 ${isMobileView ? "mobile-btn-height" : ""}`}
            color={CustomButtonColor.PRIMARY}
            type={CustomButtonTypes.BUTTON}
            onClick={() =>
              !isLastStep
                ? onPositiveActionClick(ButtonClickType.NEXT)
                : setShowConfirmModa(true)
            }
            disabled={disableNextButton}
          >
            {!isLastStep ? next : "SUBMIT"}
          </CustomButton>
        </div>
      </div>
    </span>
  );
};
